import Vue from 'vue'
import DateFilters from './date'
import TextFilters from './text'
import { capitalize } from 'lodash'

Vue.use(DateFilters)
Vue.use(TextFilters)

Vue.filter('capitalise', function (value) {
  return capitalize(value)
})
